import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import slugs from '../../data/blog'
import './index.scss'

const fmt = (d) =>
  new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

const parseFrontmatter = (raw) => {
  const match = raw.match(/^---\n([\s\S]*?)\n---/)
  if (!match) return {}
  const fm = {}
  match[1].split('\n').forEach((line) => {
    const [k, ...v] = line.split(':')
    if (k) fm[k.trim()] = v.join(':').trim().replace(/^['"]|['"]$/g, '')
  })
  const tagsMatch = match[1].match(/tags:\s*\[([^\]]*)\]/)
  fm.tags = tagsMatch
    ? tagsMatch[1].split(',').map((t) => t.trim().replace(/^['"]|['"]$/g, '')).filter(Boolean)
    : []
  return fm
}

const Blog = () => {
  const [posts, setPosts] = useState([])

  useEffect(() => {
    Promise.all(
      slugs.map((slug) =>
        fetch(`/posts/${slug}.md`)
          .then((r) => r.text())
          .then((raw) => ({ slug, ...parseFrontmatter(raw) }))
          .catch(() => ({ slug, title: slug }))
      )
    ).then(setPosts)
  }, [])

  return (
    <div className='bl-root'>
      <div className='bl-inner'>
        <div className='bl-eyebrow'>( BLOG )</div>
        <h1 className='bl-heading'>
          <span className='bl-heading__bright'>Writing.</span> Things I've built, solved, or fallen
          down a rabbit hole researching long enough to write about.
        </h1>

        <div className='bl-list'>
          {posts.map((p) => (
            <Link key={p.slug} to={`/post/${p.slug}`} className='bl-row'>
              <div className='bl-row__left'>
                <div className='bl-row__title'>{p.title || p.slug}</div>
                {p.description && <div className='bl-row__desc'>{p.description}</div>}
                {p.tags?.length > 0 && (
                  <div className='bl-row__tags'>
                    {p.tags.map((t) => <span key={t} className='bl-tag'>{t}</span>)}
                  </div>
                )}
              </div>
              {p.date && <div className='bl-row__date'>{fmt(p.date)}</div>}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Blog
